import React, {useState, useEffect, useMemo}  from "react";
import ReactModal from "react-modal";
import { Input } from "@components/form";
import { Draggable} from "@components";
import { FormProvider, useForm } from "react-hook-form";
import { useLectureInvoiceModal } from "@hooks";
import {LectureInvCompanyModal} from "./LectureInvCompanyModal";

function LectureInvoiceModal({ isOpen, onClose, isEdit, lectureId, defaultData, onSuccess }) {

  const {insertMut, updateMut } = useLectureInvoiceModal(lectureId);

  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const containerStyle = {
    maxWidth: "770px",
    minWidth: "770px",
    maxHeight: "260px",
    minHeight: "260px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const initValue = useMemo(() => ({
    invoiceId  : defaultData?.invoiceId || null,   // 수정일 때만 존재
    bizRegNo   : defaultData?.bizRegNo  || "",
    companyNm  : defaultData?.companyNm || "",
    studentCnt : defaultData?.studentCnt?? 1,
    totalAmt   : defaultData?.totalAmt  ?? 0,
  }), [defaultData]);

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const methods = useForm({ defaultValues: initValue });
  const { handleSubmit, reset, setValue, watch } = methods;

  useEffect(() => {
    if (isOpen) reset(initValue);
  }, [isOpen, initValue, reset]);




  const handleSearchConfirm = (comp) => {
    // 선택한 회사 정보를 react-hook-form에 반영
    setValue("bizRegNo", comp.bizRegNo,  { shouldValidate:true });
    setValue("companyNm", comp.companyNm, { shouldValidate:true });
    
    setSearchModalOpen(false);
  };

  const onSubmit = async (payload) => {

    try {
      const mut = isEdit ? updateMut : insertMut;
      const response = await mut.mutateAsync(payload);
      onSuccess(response);
      onClose();
    } catch (e) {
      alert(e.message || "저장 실패");
    }
  };

  const onError = (err) => {
    alert("필수 입력란을 확인하세요.");
  }

  return (
  <>  
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>계산서 단체 {isEdit ? '수정' : '등록'}</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="modal-content">
          <div className="table-container">
            <table className="table-write" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "15%" }} />
                <col />

              </colgroup>
              <tbody>
                <tr>
                  <th>사업장 <span className="red">*</span></th>
                  <td>
                    <div className="input-btn-wrap">
                      <Input
                        name="companyNm"
                        placeholder="사업장을 선택하세요."
                        divStyle={{width:'calc(100% - 40px)'}}
                        rules={{ required:true }}
                        readOnly
                      />
                      <button
                        type="button"
                        onClick={() => setSearchModalOpen(true)}
                        className="search-icon"
                        />
                    </div>
                  </td>
                  <th>사업자등록번호</th>
                  <td><Input name="bizRegNo" readOnly /></td>
                </tr>
                <tr>
                  <th>수강생 수 <span className="red">*</span></th>
                  <td><Input type="number" name="studentCnt" rules={{ required:true }}/></td>
                  <th>총 수강료 <span className="red">*</span></th>
                  <td><Input type="number" name="totalAmt" rules={{ required:true }} /></td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>

        <div className="modal-btn-wrap btn-right-box">
            <ul>
                <li><button type="button" className="btn-cancel" onClick={onClose}>닫기</button></li>
                <li><button type="submit" className="btn-save">저장</button></li>
                
            </ul>
        </div>
      </form>  
      </FormProvider>
      </div>
    </ReactModal>
    <LectureInvCompanyModal
        isOpen={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
        onConfirm={handleSearchConfirm}
      />
</>
  );
}

export {LectureInvoiceModal};
